import { useState, useCallback } from 'react';

export function useExpandedArticles() {
  const [expanded, setExpanded] = useState<Set<string>>(new Set());

  const toggle = useCallback((key: string) => {
    setExpanded((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  }, []);

  const open = useCallback((key: string) => {
    setExpanded((prev) => new Set(prev).add(key));
  }, []);

  const collapseAll = useCallback(() => {
    setExpanded(new Set());
  }, []);

  const expandAll = useCallback((keys: string[]) => {
    setExpanded(new Set(keys));
  }, []);

  const isExpanded = useCallback(
    (key: string) => expanded.has(key),
    [expanded]
  );

  return { toggle, open, collapseAll, expandAll, isExpanded };
}
